import { useEffect, useState } from "react";
import { Image } from "../image/image";
import { Text } from "../text/text";
import { DEFAULT_ICON } from "../../config/constants";

import styles from "./adminHeader.module.css"
import AdminAPI from "../../api/AdminAPI";

export const AdminHeader = ({ title = "", userId = null }) => {
    const [userData, setUserData] = useState(null);

    useEffect(() => {
        if (!userId) return;
        AdminAPI
            .fetchUserInfo(userId)
            .then(res => setUserData(res))
            .catch(console.error);
    }, [userId]);

    return (
        <header className={styles.header}>
            <Text as="h1" variant="h1" className={styles.header_title}>{title}</Text>
            {
                !!userId && !!userData &&
                <div className={styles.header_user_info}>
                    <Image width="34px" height="34px" className={styles.header_user_image} objectFit="cover" src={userData.photo || DEFAULT_ICON} />
                    <Text as="div" variant="h2" className={styles.header_user_name}>{userData.name}</Text>
                </div>
            }
            {
                !!userId && !userData &&
                <div style={{height: "34px"}} />
            }
        </header>
    )
}